export default "__VITE_ASSET__DtHM_Kb7__"